import { useAdminUsers } from '../../hooks';
import './Admin.css';

export function UsersSection() {
  const { users, isLoading } = useAdminUsers();

  const formatLastActivity = (dateStr: string | null) => {
    if (!dateStr) return 'Нет данных';
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return 'Сегодня';
    if (days === 1) return 'Вчера';
    if (days < 7) return `${days} дн. назад`;
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <div className="admin-section-header-left">
          <span className="admin-section-icon">👥</span>
          <span className="admin-section-title">Пользователи</span>
        </div>
        {users && users.length > 0 && (
          <span className="admin-section-count">{users.length}</span>
        )}
      </div>

      <div className="admin-section-body">
        {isLoading ? (
          <div className="admin-section-loading">
            <div className="admin-section-spinner" />
          </div>
        ) : !users || users.length === 0 ? (
          <div className="admin-empty-state">
            <div className="admin-empty-state-icon">👤</div>
            <div>Нет зарегистрированных пользователей</div>
          </div>
        ) : (
          <div className="admin-user-list">
            {users.map((user, index) => (
              <div
                key={user.chatId}
                className="admin-user-item admin-animate-item"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="admin-user-info">
                  <div className="admin-user-name">
                    {user.firstName || user.lastName
                      ? `${user.firstName || ''} ${user.lastName || ''}`.trim()
                      : 'Без имени'}
                  </div>
                  {user.username && (
                    <div className="admin-user-username">@{user.username}</div>
                  )}
                  <div className="admin-user-activity">
                    Активность: {formatLastActivity(user.lastActivity)}
                  </div>
                </div>
                <div className="admin-user-badges">
                  {user.active ? (
                    <span className="admin-badge admin-badge--active">Активен</span>
                  ) : (
                    <span className="admin-badge admin-badge--inactive">Неактивен</span>
                  )}
                  {user.receiveNotifications && (
                    <span className="admin-badge admin-badge--notifications">🔔 Уведомл.</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
